import React from 'react';
import './StatCard.css';

const StatCard = ({ icon, label, value, variant = 'red', small = false }) => (
  <div className="stat-card">
    <div className={`stat-card__icon stat-card__icon--${variant}`}>
      {icon}
    </div>
    <div className="stat-card__content">
      <span className="stat-card__label">{label}</span>
      <span className={`stat-card__value${small ? ' stat-card__value--sm' : ''}`}>
        {value}
      </span>
    </div>
  </div>
);

export default StatCard;